<script lang="ts">
  import { onMount } from 'svelte';
  import { enPropriétéWebC } from '$plateforme/webComponent';
  import IllustrationProtegerOrganisation from '../accueil/animation/proteger-organisation/IllustrationProtegerOrganisation.svelte';
  import { récupèreStatistiquesMSC } from '../passerelles/statistiquesMSC';
  import BlocDiagnostic from '../ui/BlocDiagnostic.svelte';
  import Bouton from '../ui/Bouton.svelte';
  import HeroLandingPage from '../ui/HeroLandingPage.svelte';
  import Lien from '../ui/Lien.svelte';
  import MotEnExergue from '../ui/MotEnExergue.svelte';
  import EncartPromotionParcoursBasique from './EncartPromotionParcoursBasique.svelte';
  import EncartPromotionParcoursComplet from './EncartPromotionParcoursComplet.svelte';

  let organisationsAccompagnées = $state(0);

  const tagsParcoursBasique = [
    {
      id: 'TPE / PME',
      label: 'TPE / PME',
      accent: 'défaut',
      size: 'md',
      icon: 'store-2-fill',
    },
    {
      id: 'Collectivités',
      label: 'Collectivités',
      accent: 'défaut',
      size: 'md',
      icon: 'bank-fill',
    },
    {
      id: 'Associations',
      label: 'Associations',
      accent: 'défaut',
      size: 'md',
      icon: 'user-heart-fill',
    },
  ];

  const tagsParcoursComplet = [
    {
      id: 'PME / ETI',
      label: 'PME / ETI',
      accent: 'défaut',
      size: 'md',
      icon: 'building-fill',
    },
    {
      id: 'Organisations concernées NIS 2',
      label: 'Organisations concernées NIS 2',
      accent: 'défaut',
      size: 'md',
      icon: 'checkbox-circle-fill',
    },
  ];

  let enPause = $state(false);
  const libelléPause = $derived(enPause ? 'Lancer les animations' : 'Mettre les animations en pause');

  const basculePause = () => {
    enPause = !enPause;
  };

  let pageSource = $state('');

  onMount(async () => {
    pageSource = `${window.location.pathname}-hero`;
    const { démarchesDeSécurisationArrondies } = await récupèreStatistiquesMSC();
    organisationsAccompagnées = démarchesDeSécurisationArrondies;
  });
</script>

<div class="section-hero-et-tuiles">
  <HeroLandingPage
    description="Rejoignez notre programme d'accompagnement gratuit."
    propriétésFilAriane={{ feuille: 'Protéger mon organisation' }}
    tag={`+${organisationsAccompagnées} organisations déjà accompagnées 🚀`}
    class="hero-landing-page"
  >
    {#snippet titreHtml()}
      Je <MotEnExergue motif="cercle">protège</MotEnExergue> mon organisation contre les cyber&shy;attaques
    {/snippet}
    {#snippet actions()}
      <Lien
        apparence="bouton"
        etire
        href={`/modules/1?pageSource=${pageSource}`}
        libelle="Se lancer en 12 mesures"
        taille="lg"
        type="primaire"
      />
      <Lien
        apparence="bouton"
        etire
        href={`/parcours-complet?pageSource=${pageSource}`}
        libelle="Rejoindre le programme complet"
        taille="lg"
        type="secondaire"
      />
    {/snippet}
    {#snippet illustration()}
      <figure class="illustration">
        <IllustrationProtegerOrganisation {enPause} />
        <div class="controle-animation">
          <Bouton
            type="secondaire"
            icone={enPause ? 'play-circle-line' : 'pause-circle-line'}
            iconeSeule
            libelle={libelléPause}
            titre={libelléPause}
            surClic={basculePause}
          />
        </div>
      </figure>
    {/snippet}
  </HeroLandingPage>

  <div class="section-tuiles">
    <dsfr-container class="conteneur-tuiles">
      <lab-anssi-carrousel-tuiles>
        <dsfr-tile title="Gratuit" action-markup="false" no-link size="sm"></dsfr-tile>
        <dsfr-tile title="Conçu par l'agence cyber de l'État" action-markup="false" no-link size="sm"></dsfr-tile>
        <dsfr-tile title="100% en ligne" action-markup="false" no-link size="sm"></dsfr-tile>
      </lab-anssi-carrousel-tuiles>
    </dsfr-container>
  </div>
</div>

<section class="section-parcours-basique">
  <EncartPromotionParcoursBasique
    titre="La cybersécurité est étrangère à votre organisation ?"
    description="Accédez à 12 mesures simples pour protéger dès maintenant votre organisation contre les cyberattaques et prendre votre Cyberdépart ! 🚀"
  >
    {#snippet tags()}
      <dsfr-tags-group tags={enPropriétéWebC(tagsParcoursBasique)}></dsfr-tags-group>
    {/snippet}
  </EncartPromotionParcoursBasique>
</section>

<section class="section-diagnostic">
  <dsfr-container>
    <BlocDiagnostic
      titre="Vous préférez échanger avec un Aidant cyber ?"
      labelBouton="Demander un accompagnement gratuit"
      lienBouton="/cyberdepart/diagnostic-gratuit?origine=landing-parcours-securisation"
    >
      {#snippet description()}
        <p class="texte-standard-md">
          Demandez à bénéficier du diagnostic cyberdépart&nbsp;: un accompagnement d’une heure gratuit avec un Aidant
          cyber bénévole.
        </p>
        <ul class="texte-standard-md">
          <li>Réunissez votre direction, les services compétents et votre prestataire informatique.</li>
          <li>Échangez et impulsez une dynamique interne&nbsp;!</li>
        </ul>
      {/snippet}
    </BlocDiagnostic>
  </dsfr-container>
</section>

<section class="section-parcours-complet">
  <EncartPromotionParcoursComplet
    titre="Votre organisation agit déjà pour sa cybersécurité ?"
    description="Accédez à 58 mesures pour vous protéger contre les 5 risques cyber les plus courants."
  >
    {#snippet tags()}
      <dsfr-tags-group tags={enPropriétéWebC(tagsParcoursComplet)}></dsfr-tags-group>
    {/snippet}
  </EncartPromotionParcoursComplet>
</section>

<section class="section-pied-de-page">
  <dsfr-container>
    <p class="lien-test-maturite">
      <img class="icone-fleche" src="/assets/images/icone-fleche-droite-cercle-plein.svg" alt="" />
      <span>
        Trouvez le parcours adapté à votre organisation à l'aide de notre test de maturité cyber. <Lien
          href="/test-maturite"
          libelle="Débuter le test"
          neutre
        />
      </span>
    </p>

    <hr class="separateur" />
    <Lien href="#" libelle="Haut de page" taille="md" icone="arrow-up-fill" />
  </dsfr-container>
</section>

<style lang="scss">
  @use '../../../assets/styles/responsive' as *;
  @use '../../../assets/styles/grille' as *;

  .section-hero-et-tuiles {
    background-color: var(--pink-tuile-850-200);
  }

  .section-tuiles {
    .conteneur-tuiles {
      padding-block: 0;
    }

    lab-anssi-carrousel-tuiles {
      margin-block-start: -2.5rem;
    }
  }

  .section-parcours-basique {
    background-color: var(--pink-macaron-850-200);
    padding-block: 6rem;
  }

  .section-diagnostic {
    padding-block: 3.5rem;
  }

  .section-parcours-complet {
    background-color: var(--brown-cafe-creme-975-75);
    padding-block: 6rem;
  }

  .section-pied-de-page {
    padding-block: 3rem;
  }

  .lien-test-maturite {
    align-items: flex-start;
    color: var(--text-default-grey);
    display: flex;
    font-size: 1.125rem;
    gap: 0.5rem;
    line-height: 1.75rem;
    margin: 0;
  }

  .icone-fleche {
    align-self: inherit;
    flex-shrink: 0;
    width: 24px;
  }

  .separateur {
    border: none;
    border-top: 1px solid var(--border-default-grey);
    margin-block: 3rem;
  }

  .illustration {
    margin: 0 auto;
    width: 100%;

    .controle-animation {
      text-align: right;
    }
  }

  .controle-animation {
    @media (prefers-reduced-motion: reduce) {
      display: none;
    }
  }
</style>
